import { Column, EditType } from '@src/model/table';
import { Domain } from '@src/dtos/version.dto';
import { isDomainValid, isValueDuplicate, nameValidation } from '@src/utils/validationUtils';
import { createDescriptionColumn, createDomainActionColumn } from '@src/components/shared/table/column-factories';

export const domainsColumns: Column<Domain>[] = [
    {
        accessor: 'name',
        header: 'Name',
        width: '300px',
        displayOnEdit: true,
        type: EditType.Text,
        getPlaceholder: () => 'Enter name',
        validationRules: [isValueDuplicate, (value) => nameValidation(value, 50)],
        mandatory: true,
        maxLength: 50
    },
    {
        accessor: 'domainUrl',
        header: 'Domain',
        width: '300px',
        displayOnEdit: true,
        type: EditType.Text,
        getPlaceholder: () => 'Enter domain',
        validationRules: [isValueDuplicate, isDomainValid],
        mandatory: true,
        description: 'Only domain format is supported such as example.com or example.co.uk.\nSub-domains and suffix beyond the domain are not supported.',
        maxLength: 50
    },
    createDomainActionColumn(),
    createDescriptionColumn(520, 100)
];
